import { FaRegComment } from "react-icons/fa";
import { AiOutlineLike, AiFillLike } from "react-icons/ai";
import AddComment from "./AddComment";
import Comments from "./Comments";
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";

const Details = ({
  published,
  updated,
  el,
  user,
  id,
  likes,
  setShow,
  like,
  show,
  comments,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div
        key={el._id}
        className="w-[100%] lg:w-[80%] dark:w-[100%] dark:lg:px-[9rem] m-auto dark:h-screen dark:lg:h-auto py-20 px-4 flex flex-col flex-shrink overflow-y-auto lg:overflow-y-hidden dark:bg-[#0d0c11] pb-[12rem]"
      >
        <h2 className="tracking-widest text-xs title-font font-medium text-indigo-500 dark:text-indigo-400 mb-1">
          {el.categories.map((c) => c.name + " | ")}
        </h2>
        <p className="inline-flex items-center">
          <img
            alt="blog"
            src={el.user?.avatar}
            className="w-8 h-8 rounded-full flex-shrink-0 object-cover object-center"
          />
          <span className="flex-grow flex flex-col pl-3">
            <span className="title-font font-medium text-gray-900 dark:text-white">
              {el.user.name}
            </span>
            <span className="text-[16px] text-gray-600 dark:text-gray-400">
              Published on {published.toDateString()}
            </span>
          </span>
        </p>
        <h1 className="text-4xl font-bold mb-2 capitalize dark:text-white">
          {el.title}
        </h1>

        <div className="mt-2 dark:text-white capitalize">{parse(el.body)}</div>
        <div className="flex justify-start">
          {user?.user?.email === el.user.email ? (
            <>
              <button
                className="flex mr-2 my-2 text-white bg-[#1D4ED8] border-0 py-1 px-6 focus:outline-none hover:bg-indigo-600 rounded text-md"
                onClick={() => navigate(`/blogs/${id}/edit`)}
              >
                Edit
              </button>
              <button
                className="flex mx-2 my-2 text-white bg-[#1D4ED8] border-0 py-1 px-6 focus:outline-none hover:bg-indigo-600 rounded text-md"
                onClick={() =>
                  navigate(`/blogs/${id}/delete`, { replace: true })
                }
              >
                Delete
              </button>
            </>
          ) : (
            ""
          )}
        </div>
        <span className="text-[16px] text-gray-600 dark:text-gray-400">
          Last updated {updated.toLocaleString()}
        </span>
        <div className="flex mt-4 items-center">
          <p className="mr-4 text-2xl cursor-pointer" onClick={() => like()}>
            <span className="flex items-center">
              {likes.filter((l) => l.user._id === user?.user?._id).length ? (
                <AiFillLike className="dark:text-white" />
              ) : (
                <AiOutlineLike className="dark:text-white" />
              )}

              <span className="text-[18px] dark:text-white">
                {likes.length}
              </span>
            </span>
          </p>
          <p
            className="ml-4 text-2xl cursor-pointer"
            onClick={() => setShow(!show)}
          >
            <span className="flex items-center">
              <FaRegComment className="dark:text-white" />
              <span className="text-[18px] dark:text-white ml-[1px]">
                {comments.length}
              </span>
            </span>
          </p>
        </div>
        {show && <AddComment id={id} />}
        {show && <Comments id={id} />}
      </div>
    </>
  );
};

export default Details;
